import z from "zod";

export const zPlanning2TableSettings = z.object({
  columnsOrder: z.string().array().nullish(),
  hiddenColumns: z.string().array().nullish(),
  columnWidths: z.record(z.string(), z.number()).nullish(),
  showGantt: z.boolean().nullish(),
  timeScale: z.number().min(0).max(100).nullish(),
  rightWidth: z.number().or(z.string()).nullish(),
  showArrows: z.boolean().nullish(),
  fixedColumns: z.number().nullish(),
});

export type ZPlanning2TableSettings = z.infer<typeof zPlanning2TableSettings>;
